import type {ModelToProps} from '../../Base/types';

import {QuestionModel} from '../Question.model';

type Option = {
  id: string;
  score?: number;
  title: string;
};

export class ChoiceQuestionModel extends QuestionModel {
  options: Option[];

  constructor(props: ChoiceQuestionModel.Props) {
    super(props);
    this.options = props.options;
  }
}

export namespace ChoiceQuestionModel {
  export type Props = ModelToProps<ChoiceQuestionModel>;

  export const isChoiceQuestionProps = (
    props: QuestionModel.Props,
  ): props is ChoiceQuestionModel.Props => {
    return props.type === 'multiple_choice' || props.type === 'checkboxes';
  };
}
